import { render, staticRenderFns } from "./ListOrdersCompleted.vue?vue&type=template&id=1cb4b89a"
import script from "./ListOrdersCompleted.vue?vue&type=script&lang=js"
export * from "./ListOrdersCompleted.vue?vue&type=script&lang=js"
import style0 from "./ListOrdersCompleted.vue?vue&type=style&index=0&id=1cb4b89a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports